// removed by extract-text-webpack-plugin
module.exports = {"field":"theme__field___1T2D0","text":"theme__text___rxx-p","thumb":"theme__thumb___1pMry","ripple":"theme__ripple___1I9tv","on":"theme__on___p92Yp","off":"theme__off___25ui_","input":"theme__input___3BTU_","switch-on":"theme__switch-on___2Bwve","switch-off":"theme__switch-off___1ZBFp","disabled":"theme__disabled___1CQ_q theme__field___1T2D0"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/switch/theme.css
// module id = 1453
// module chunks = 0